module.exports = __webpack_public_path__ + "static/img/DPS1.1127ba54.png";